import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import MemberImage from '../members/MemberImage.react';
import ImageSvg from '../images/ImageSvg.react';
import ImageUpload from '../images/ImageUpload.react';
import cx from '../../utils/cx.js';
import EmoticonsContainer from '../emoticons/EmoticonsContainer.react';
import EmoticonsButton from '../emoticons/EmoticonsButton.react';
import LazyLoad from 'react-lazyload';
import { withResizeDetector } from 'react-resize-detector/build/withPolyfill';

import Giphy from '../giphy/Giphy.react';
import GiphyButton from '../giphy/GiphyButton.react';
import popup from '../../../app/popup.js';
import modal from '../../../app/modal.js';
import _ from 'lodash';
import responsiveness from '../../../../../../sass/foundation/variables/responsiveness.scss';

const ReactPropTypes = PropTypes;

// Vai norādīt fokusu uz ievades lauka
let setFocus = false;

const key = [];

function setSelectionRange(input, start, end) {
  if (input.setSelectionRange) {
    input.focus();
    input.setSelectionRange(start, end);
    input.focus();
  } else if (input.createTextRange) {
    const range = input.createTextRange();
    range.collapse(true);
    range.moveEnd('character', end);
    range.moveStart('character', start);
    range.select();
  }
}

function setCaretToPos(input, pos) {
  setSelectionRange(input, pos, pos);
}

class MessageComposer extends React.Component {
	static displayName = 'MessageComposer';

	static propTypes = {
	  disabled: ReactPropTypes.bool,
	  showArrow: ReactPropTypes.bool,
	  senderId: ReactPropTypes.string, // tas kurš raksta
	  showSubscription: ReactPropTypes.bool,
	  showOverConversationLimit: ReactPropTypes.bool,
	  showVerification: ReactPropTypes.bool,
	  smallInput: ReactPropTypes.bool, // vai izmantot mazāko ievades lauku
	  transparent: ReactPropTypes.bool, // transparent background
	  disableResize: ReactPropTypes.bool, // nevar mainīt input izmēru
	  onMessageSubmit: ReactPropTypes.func, // izpilda onSubmit
	  onMessageChange: ReactPropTypes.func, // izpilda onChange
	  onChangeEnter: ReactPropTypes.func, // izpilda uz enter checkbox
	  disableVideo: ReactPropTypes.bool, // videočata poga
	  initialMessage: ReactPropTypes.string, // sākuma teksts, kuru padod inputam
	  initialMessageAfterSubmit: ReactPropTypes.string, // sākuma teksts, kuru padod inputam pēc submit
	  submitOnEnter: ReactPropTypes.bool,
	  characterLimit: ReactPropTypes.number,
	  inPopup: ReactPropTypes.bool,
	};

  // TODO: take iamge base path from props
	static defaultProps = (function () {
	  let imgBasePath = '/images/get/l/';
	  if (_.get(globals, 'fullStaticImageUri', null)) {
	    imgBasePath = globals.fullStaticImageUri + 'l/';
	  } else {
	    imgBasePath = `${window.location.protocol}//${window.location.host}${imgBasePath}`;
	  }
	  return {
	    disabled: false,
	    senderId: null,
	    showArrow: true,
	    showSubscription: false,
	    showOverConversationLimit: false,
	    showVerification: false,
	    smallInput: false,
	    disableResize: false,
	    transparent: false,
	    onMessageSubmit: null,
	    onMessageChange: null,
	    onChangeEnter: null,
	    disableVideo: false,
	    initialMessage: '',
	    initialMessageAfterSubmit: '',
	    submitOnEnter: false,
	    characterLimit: null,
	    imgBasePath,
	    inPopup: false,
	  };
	}());

	state = {
	  focused: false,
	  userInput: '',
	  caretPos: false,
	  emoticonsOpen: false,
	  giphyOpen: false,
	  submitOnEnter: this.props.submitOnEnter,
	  windowOrientation: 'portrait',
	  charactersLeft: this.props.characterLimit,
	};

	// eslint-disable-next-line camelcase
	UNSAFE_componentWillReceiveProps(nextProps) {
	  // ja disabled mainās no true uz false, tad nodzēš textarea saturu
	  if ((!nextProps.disabled && this.props.disabled) || (nextProps.id !== this.props.id)) {
	    if (!this.props.preserveInput) {
	      this.setState({ userInput: '', charactersLeft: this.props.characterLimit }); // Clear the input
	    }
	    // atjaunot auto focus, ja nosūtīta vēstule
	    // setFocus = true;
	  }
	}

	componentWillUnmount() {
	  this.setState({ userInput: '', charactersLeft: this.props.characterLimit });
	}

	toggleEmoticonsPanel = (event) => {
	  event.preventDefault();
	  if (!this.verifySubmitAllowed()) {
	    return;
	  }
	  this.setState({ emoticonsOpen: !this.state.emoticonsOpen });
	  if (this.state.emoticonsOpen == false) {
	    this.setState({ giphyOpen: false });
	  }
	};

	toggleGiphyPanel = (event) => {
	  event.preventDefault();
	  if (!this.verifySubmitAllowed()) {
	    return;
	  }
	  this.setState({ giphyOpen: !this.state.giphyOpen });
	  if (this.state.giphyOpen == false) {
	    this.setState({ emoticonsOpen: false });

	    $('.unveil-giphy').unveil();
	  }
	};

	addEmoticon = (emoticon) => {
	  const textarea = this.refs.text;
	  let pos = textarea.selectionStart;
	  let userInput = `${this.state.userInput.substring(0, pos)
			+ emoticon} ${
			 this.state.userInput.substring(pos, this.state.userInput.length)}`;

	  let charactersLeft = this.props.characterLimit;
	  if (this.props.characterLimit) {
	    if (userInput.length > this.props.characterLimit) {
	      userInput = userInput.substr(0, this.props.characterLimit);
	      popup.profileVerificationMessage();
	    }
	    charactersLeft = this.props.characterLimit - userInput.length;
	  }

	  pos = pos + emoticon.length + 1;
	  this.setState({
	    userInput,
	    charactersLeft,
	    caretPos: pos,
	  });
	  textarea.focus();
	  setCaretToPos(textarea, pos);
	};

	addImage = (id, uncensored) => {
	  if (!this.verifySubmitAllowed()) {
	    return;
	  }

	  // TODO This saves gcloud image text as, for example, 'https://g.lindoamor.com/l/F3C4NgfVUO.jpg'.
	  // Which, in old versions message view, will be treated as external image.
	  // Though in new version these already get treated as local images, so in new version everything would be ok with this.
	  // Wait.. now looks like gcloud images are also treated as local in old version too.
	  // So try this now. Also because seems that those 's.lindoamor.com' aren't working properly anymore. (?)
	  const basePath = id.length < 30 ? _.get(globals, 'gcloudUri', '') + 'l/' : this.props.imgBasePath;
	  const imgId = id.length < 30 ? id + '.jpg' : id;
	  const uncensoredParam = uncensored ? '?uncensored=true' : '';
	  if (id.length) {
	    this.props.onMessageSubmit(basePath + imgId + uncensoredParam, true, true);
	  }
	  // But, for now, still save image text as in old version
	  // This saves, for example 'https://s.lindoamor.com/images/get/l/F3C4NgfVUO.jpg' or 'https://otrapuse.lv/images/get/l/F3C4NgfVUO.jpg'.
	  /* if (id.length) {
	    let imageUrl = this.props.imgBasePath + id;
	    this.props.onMessageSubmit(imageUrl, true);
	  } */
	};

	addGif = (url) => {
	  if (url.length) {
	    this.props.onMessageSubmit(url, true, true);
	    this.setState({ giphyOpen: !this.state.giphyOpen });
	  }
	};

	componentDidMount() {
	  if (!this.props.initialMessage) {
	    return;
	  }

	  let userInput = this.props.initialMessage;
	  let charactersLeft = this.props.characterLimit;
	  if (this.props.characterLimit) {
	    if (userInput.length > this.props.characterLimit) {
	      userInput = userInput.substr(0, this.props.characterLimit);
	    }
	    charactersLeft = this.props.characterLimit - userInput.length;
	  }

	  this.setState({ userInput, charactersLeft });
	}

  // TODO This probably should be adjusted
	componentDidUpdate() {
	  const { caretPos, submitOnEnter, windowOrientation } = this.state;

	  const newCaretPos = false;
	  const newSubmitOnEnter = window.innerWidth <= responsiveness.breakpoint ? false : this.props.submitOnEnter;
	  const newWindowOrientation = window.innerWidth <= window.innerHeight ? 'portrait' : 'landscape';

	  if (caretPos === newCaretPos
	    && submitOnEnter === newSubmitOnEnter
	    && windowOrientation === newWindowOrientation
	  ) {
	    return;
	  }

	  if (caretPos !== false) {
	    const textarea = this.refs.text;
	    setCaretToPos(textarea, this.state.caretPos);
	  }

	  this.setState({
	    caretPos: newCaretPos,
	    submitOnEnter: newSubmitOnEnter,
	    windowOrientation: newWindowOrientation,
	  });

	  // uzliek auto focus ievades laukam
	  if (setFocus && this.refs.text) {
	    this.refs.text.focus();
	    setFocus = false;
	  }
	}

	render() {
	  /* const infoText = function () {
	    if (!_.get(translations, 'txt: Atceies, ka tērzētavā un sarakstēs Tev nav maska!', null)) {
	      return null;
	    }

	    return (
	      <div className="messageComposer-main-info">
	        {_.get(translations, 'txt: Atceies, ka tērzētavā un sarakstēs Tev nav maska!', '')}
	      </div>
	    );
	  }; */

	  const characterRestriction = () => {
	    if (!this.props.characterLimit) {
	      return (null);
	    }

	    const { charactersLeft } = this.state;

	    return (
	      <div className="tss tar mtxs mbs">
	        <div>
	          {_.get(translations, 'txt: Atlikušais rakstzīmju skaits:', '')}
	          <span className={`mlxs${charactersLeft < 11 ? ' tcr' : ''}`}>{charactersLeft}</span>
	        </div>
	        <div
	          dangerouslySetInnerHTML={{__html: _.get(translations, 'txt: Verificē profilu, lai rakstītu neierobežota garuma vēstules.', '')}}
	        />
	      </div>
	    );
	  }

	  let hideImageUpload = true;
	  if (this.props.showImgUpload !== false) {
	    hideImageUpload = false;
	  }

	  let hideGiphyButton = false;
	  if (this.props.showGiphy == false) {
	    hideGiphyButton = true;
	  }

    return (
      <div
        className={cx([
          'messageComposer',
          'messageComposer-messages',
          ['messageComposer--transparent', this.props.transparent],
          ['messageComposer--hideBorder', this.props.transparent],
          ['has-arrow', this.props.showArrow],
          ['no-resize', this.props.disableResize],
          ['is-focused', this.state.focused],
        ])}
        data-emoticon-target
      >
        <div className="messageComposer-image">
          <MemberImage
            key={this.props.senderId}
            memberId={this.props.senderId}
            vipOn={_.get(globals, 'currentMember.vipOn', false)}
          />
        </div>
        <div className="messageComposer-main has-arrow">
          <form
            className="form"
            value=""
            onSubmit={this._onSubmit}
          >
            <Giphy
              isOpen={this.state.giphyOpen}
              addGif={this.addGif}
              toggleGiphyPanel={this.toggleGiphyPanel}
            />
            <textarea
              name="text"
              className={cx([
                'form-control',
                'messageComposer-main-input',
                ['messageComposer-main-input--small', this.props.smallInput],
                ['messageComposer-main-input--nomargin', this.props.characterLimit],
              ])}
              placeholder={_.get(translations, 'txt: Rakstīt ...', '')}
              rows="1"
              ref="text"
              value={this.state.userInput}
              start={this.state.selectionStart}
              disabled={this.props.disabled}
              onFocus={this._onFocus}
              onClick={this._onClick}
              onBlur={this._onBlur}
              onChange={this._onChange}
              onInput={this._onInput}
              onDoubleClick={this._onDoubleClick}
              onDragEnd={this._onDragEnd}
              onKeyDown={this._onKeyPress}
              onKeyUp={this._onKeyUp}
            />
            {/* infoText() */}
            {characterRestriction()}
            <div className="messageComposer-main-buttons">
              <EmoticonsButton toggleEmoticonsPanel={this.toggleEmoticonsPanel} />
              {!hideGiphyButton && (
                <GiphyButton toggleGiphyPanel={this.toggleGiphyPanel} />
              )}
              <EmoticonsContainer
                addEmoticon={this.addEmoticon}
                isOpen={this.state.emoticonsOpen}
                orientation={this.state.windowOrientation}
              />
              {!hideImageUpload && (
                <ImageUpload
                  hide={hideImageUpload}
                  addImage={this.addImage}
                  verifySubmitAllowed={this.verifySubmitAllowed.bind(this)}
                />
              )}
              <button
                type="submit"
                className={cx([
                  'btn btn--a btn--small btn--iconLeft mlm messageSubmit',
                  ['has-loader', this.props.disabled],
                  ['hide', this.state.submitOnEnter],
                ])}
                disabled={this.props.disabled}
              >
                <span className="btn-text">{_.get(translations, 'txt: Nosūtīt', '')}</span>
                <span className="btn-static">
                  <ImageSvg svg="icon-plane" iconClass="icon--center icon--plane" />
                </span>
              </button>
              <label className="messageComposer-main-submitOnEnter">
                <span>{_.get(translations, 'txt: submit on enter', '')}</span>
                <input
                  type="checkbox"
                  onChange={this._onChangeEnter}
                  checked={this.state.submitOnEnter}
                />
              </label>
            </div>
          </form>
        </div>
      </div>
    );
  }

	verifySubmitAllowed() {
	  // info logs, ja ieslēgts VIP
	  if (_.get(globals, 'currentMember.vipOn', false)) {
	    popup.vipOnMessage();
	    return false;
	  }

	  // info logs, ja nav abo
	  if (this.props.showSubscription) {
	    popup.subscriptionMessage();
	    return false;
	  }

	  // info logs, ja pāri limitam
	  if (this.props.showOverConversationLimit) {
	    popup.overConversationLimitMessage();
	    return false;
	  }

	  // info logs, ja pending
	  if (_.get(globals, 'currentMember.status', '') == 'pending') {
	    popup.pendingMessage();
	    return false;
	  }

	  return true;
	}

	submit = () => {
	  if (!this.verifySubmitAllowed()) {
	    return;
	  }

	  let userInput = '';
	  let preserveInput = false;
	  let charactersLeft = this.props.characterLimit;
	  if (this.props.initialMessageAfterSubmit) {
	    userInput = this.props.initialMessageAfterSubmit;
	    preserveInput = true;
	    if (this.props.characterLimit) {
	      if (userInput.length > this.props.characterLimit) {
	        userInput = userInput.substr(0, this.props.characterLimit);
	      }
	      charactersLeft = this.props.characterLimit - userInput.length;
	    }
	  }

	  this.setState({ userInput, charactersLeft });

	  if (this.props.disabled) {
	    return;
	  }

	  const text = ReactDOM.findDOMNode(this.refs.text).value.trim();

	  if (text.length) {
	    this.props.onMessageSubmit(text, preserveInput);
	  }
	};

	_onSubmit = (e) => {
	  e.preventDefault();

	  this.submit();
	};

	_onFocus = () => {
	  this.setState({ focused: true });
	};

	_onBlur = () => {
	  this.setState({ focused: false });
	};

	_onChange = (e) => {
	  if (!this.props.inPopup) {
	    const popups = document.getElementsByClassName('vex');
	    // ja jau ir atvērti popup logi, neko nevajag darīt
	    if (popups.length) {
	      this.setState({ focused: false });
	      return;
	    }
	  }

	  // info logs, ja ieslēgts VIP
	  if (_.get(globals, 'currentMember.vipOn', false)) {
	    popup.vipOnMessage();
	    return;
	  }

	  // info logs, ja nav verificēts epasts
	//   if (this.props.showVerification) {
	//     popup.verificationMessage();
	//     return;
	//   }

	  // info logs, ja nav abo
	  if (this.props.showSubscription && _.get(globals, 'currentMember.status', '') !== 'simulated') {
	    popup.subscriptionMessage();
	    return;
	  }

	  // info logs, ja pāri limitam
	  if (this.props.showOverConversationLimit) {
	    if (!modal.isOpen()) {
	      popup.overConversationLimitMessage();
	    }
	    return;
	  }

	  // info logs, ja pending
	  if (_.get(globals, 'currentMember.status', '') == 'pending') {
	    popup.pendingMessage();
	    return;
	  }

	  let userInput = e.target.value;
	  let { charactersLeft } = this.state;
	  if (this.props.characterLimit) {
	    if (userInput.length > this.props.characterLimit) {
	      userInput = userInput.substr(0, this.props.characterLimit);
	      popup.profileVerificationMessage();
	    }
	    charactersLeft = this.props.characterLimit - userInput.length;
	  }

	  this.setState({ userInput, charactersLeft });

	  // padod datus atpakaļ
	  // ja ir submitOnEnter un tika nospiests enter, tad nevajag veikt izmaiņas
	  if (this.props.onMessageChange
	    && (!this.props.submitOnEnter || (this.keyName(e) !== 'Enter'))
	  ) {
	    this.props.onMessageChange(userInput);
	  }
	};

	keyName = (e) => {
	  if (typeof e.keyIdentifier !== 'undefined') {
	    // safari
	    return e.keyIdentifier;
	  }

	  return e.key;
	};

	_onChangeEnter = (e) => {
	  const checked = e.target.checked;
	  this.props.onChangeEnter(checked);
	  this.setState({ submitOnEnter: checked });
	};

	_onKeyUp = (e) => {
	  e = e || event; // to deal with IE
	  key[this.keyName(e)] = e.type == 'keydown';
	};

	_onKeyPress = (e) => {
	  // submit uz enter
	  e = e || event; // to deal with IE
	  key[this.keyName(e)] = e.type == 'keydown';

	  if (this.state.submitOnEnter && key.Enter && !key.Shift) {
	    this.submit();
	    key.Enter = false;
	  }
	};
}

module.exports = withResizeDetector(MessageComposer);
